import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import Select from 'react-select'; // Import react-select
import './create.css';
import AWS from 'aws-sdk';
import { Discount } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';

const RoomRegisterCreate = () => {

    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();

    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessages, setErrorMessages] = useState({});
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [checkouttime, setcheckouttime] = useState();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, branchId, userId, token, logout]);


    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, token, logout]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    const [formData, setFormData] = useState({
        // Rooms
        RoomId: id,
        SlabId: "",
        RentAmount: 0.0, // Initialize with a default value
        Discount: "",
        TotalStay: "",
        Purpose: "",
        CheckIn: "",
        CheckOut: "",
        FinalAmount: "",
        CreatedBy: userId,
        // Customer
        FirstName: "",
        LastName: "",
        Email: "",
        ContactNumber: "",
        AddressLine1: "",
        AddressLine2: "",
        // ID Proofs
        AddressProofId: "",
        AddressproofNo: "",
        Remarks: "",
        CheckInTime: "",
    });

    // Compute `RentAmount` dynamically later in your component or when state updates
    useEffect(() => {
        const calculatedRentAmount = (
            (parseFloat(formData.Amount) || 0.0) - (parseFloat(formData.Discount) || 0.0)
        ).toFixed(2);

        setFormData((prevFormData) => ({
            ...prevFormData,
            RentAmount: calculatedRentAmount,
            FinalAmount: (formData.RentAmount) * (parseFloat(formData.TotalStay) || 0.0),
        }));
    }, [formData.Amount, formData.Discount, formData.TotalStay]);

    useEffect(() => {
        const calculatedFinalAmount = (
            (parseFloat(formData.TotalStay) || 0.0) * (parseFloat(formData.RentAmount) || 0.0)
        ).toFixed(2);

        setFormData((prevFormData) => ({
            ...prevFormData,
            FinalAmount: calculatedFinalAmount,
        }));
    }, [formData.RentAmount, formData.TotalStay]);


    // DATA RETRIVE

    // useEffect(() => {
    //     fetchData('RoomApi', `/Details/${id}`, token)
    //         .then((response) => {
    //             setLoading(true);
    //             if (response.responseCode === '1111') {
    //                 setFormData(response.response_data.Rooms);
    //                 setSelectedItems(response.response_data.RoomRateSlab);
    //                 setcheckouttime(response.response_data.CheckOutTime);
    //                 setFormData(prevData => ({
    //                     ...prevData,
    //                     CreatedBy: userId,
    //                 }));
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Sale Details:', error);
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         });
    // }, [id]);

    useEffect(() => {
        fetchData('RoomApi', `/Details/${id}`, token)
            .then((response) => {
                setLoading(true);
                if (response.responseCode === '1111') {
                    const roomData = response.response_data.Rooms;
                    const roomRateSlab = response.response_data.RoomRateSlab;
                    let checkOutTime = response.response_data.CheckOutTime; // Assuming it's in HH:mm:ss format

                    // Convert HH:mm:ss to HH:mm AM/PM
                    if (checkOutTime) {
                        const [hours, minutes] = checkOutTime.split(':');
                        const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
                        const period = hours >= 12 ? "PM" : "AM";
                        checkOutTime = `${hours12}:${minutes} ${period}`; // e.g., 11:00 AM
                    }

                    // Set state variables
                    setFormData(roomData);
                    setSelectedItems(roomRateSlab);
                    setcheckouttime(checkOutTime || ""); // Default to empty if no CheckOutTime

                    // Update CreatedBy in FormData
                    setFormData((prevData) => ({
                        ...prevData,
                        CreatedBy: userId,
                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [id]);

    // TAB SETTING 

    const [activeTab, setActiveTab] = useState("rooms");
    const [completedSteps, setCompletedSteps] = useState({
        rooms: false,
        customer: false,
        idproofs: false,
    });

    const containerStyle = {
        fontFamily: "Arial, sans-serif",
        maxWidth: "95%",
        margin: "20px auto",
        border: "1px solid #ccc",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        overflow: "visible",
        position: "relative",
        zIndex: 1,
    };

    const stepBarStyle = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
        padding: "10px 5px",
        borderBottom: "1px solid #ccc",
        height: "50px",
        textAlign: "center",
    };

    const tabContentStyle = {
        padding: "20px",
        backgroundColor: "#fff",
    };

    const handleNextStep = () => {
        if (activeTab === "rooms") {
            setCompletedSteps((prev) => ({ ...prev, rooms: true }));
            setActiveTab("customer");
        } else if (activeTab === "customer") {
            setCompletedSteps((prev) => ({ ...prev, customer: true }));
            setActiveTab("idproofs");
        }
    };

    const handlePreviousStep = () => {
        if (activeTab === "customer") {
            setActiveTab("rooms");
        } else if (activeTab === "idproofs") {
            setActiveTab("customer");
        }
    };

    // Step styles
    const stepStyle = (isActive, isCompleted) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2,
        color: isCompleted ? "darkorange" : isActive ? "#007bff" : "#888",
    });

    const circleStyle = (isActive, isCompleted) => ({
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: isCompleted ? "#664DE5" : isActive ? "#664DE5" : "#fff",
        color: isCompleted ? "#fff" : isActive ? "#fff" : "#007bff",
        border: "1px solid #ccc",
        fontWeight: "bold",
        transition: "all 0.3s ease",
    });

    const renderStep = (stepIndex, stepName, stepPosition) => (
        <div
            className={`indexedStep ${completedSteps[stepName] ? "accomplished" : ""}`}
            style={{
                ...circleStyle(activeTab === stepName, completedSteps[stepName]),
                position: 'absolute',
                left: stepPosition === "left" ? "2%" : stepPosition === "center" ? "47%" : "85%",
                transform: stepPosition === "center" ? "translateX(-50%)" : "none",
                marginTop: '-1%'
            }}
        >
            {stepIndex}
        </div>
    );

    //RoomRateSlab
    const [slabOptions, setslabOptions] = useState([]);
    const [selectedslabOptions, setSelectedslabOptions] = useState("");
    const [roomRateSlab, setRoomRateSlab] = useState([]);
    const fetchSlab = async () => {
        try {
            const response = await fetchData('RoomRegistrationApi', `/SlabDetails/${id}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setslabOptions(options);
                setRoomRateSlab(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching RoomRate:', error);
        }
    };

    const handleSlabChange = (selectedOption) => {
        setSelectedslabOptions(selectedOption);

        const selectedSlab = roomRateSlab.find(slab => slab.Id === selectedOption.value);

        if (selectedSlab) {

            setFormData(prevFormData => ({
                ...prevFormData,
                SlabId: selectedSlab.Id,
                Amount: selectedSlab.Amount,
                Discount: 0,
                FinalAmount: selectedSlab.Amount,
                GSTRate: selectedSlab.GSTRate,

            }));
        }
    };

    useEffect(() => {
        fetchSlab();
    }, []);

    // ID CARD TYPES
    //RoomRateSlab
    const [idcardOptions, setidcardOptions] = useState([]);
    const [selectedidcardOptions, setSelectedidcardOptions] = useState("");

    const fetchIdcard = async () => {
        try {
            const response = await fetchData('RoomRegistrationApi', `/CardType/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.ID,
                    label: method.CardName
                }));
                setidcardOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Id card:', error);
        }
    }; 


    const handleIdcardChange = (selectedOption) => {
        setSelectedidcardOptions(selectedOption);

        setFormData((prevFormData) => ({
            ...prevFormData,
           AddressProofId: selectedOption.value,
        }));
    };
                           
    useEffect(() => {
        fetchIdcard();
    }, []);

    // useEffect(() => {
    //     const currentDate = new Date();
    //     const formattedCurrentDate = formatDateForInput(currentDate.toISOString().split('T')[0]);

    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         CheckIn: formattedCurrentDate,
    //     }));
    // }, []);

    const calculateTotalStay = (checkIn, checkOut) => {
        const checkInDate = new Date(checkIn);
        const checkOutDate = new Date(checkOut);
        const checkOutTime = checkouttime ? parseInt(checkouttime.split(':')[0]) : 11; // Default to 11 if checkouttime is not set
        const oneDayInMs = 24 * 60 * 60 * 1000;

        let totalStay = Math.ceil((checkOutDate - checkInDate) / oneDayInMs);

        if (totalStay <= 0 || (totalStay === 1 && checkOutDate.getHours() > checkOutTime)) {
            totalStay = 1;
        } else if (checkOutDate.getHours() > checkOutTime) {
            totalStay += 1;
        }

        return totalStay;
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        const currentDate = new Date();
        //const formattedCurrentDate = formatDateForInput(currentDate.toISOString().split("T")[0]);
        const formattedCurrentDate = currentDate.toLocaleDateString('en-CA'); 
        

        setFormData((prevFormData) => {
            const updatedData = { ...prevFormData, [name]: value, CheckIn: formattedCurrentDate };

            if (updatedData.CheckIn && updatedData.CheckOut) {
                // Ensure GSTRate and Amount exist
                const gstrate = parseFloat(updatedData.GSTRate) || 0;
                const amount = parseFloat(updatedData.Amount) || 0;
                const discount = parseFloat(updatedData.Discount) || 0;

                // Apply Discount First
                const netAmount = amount - discount; // Amount after discount

                // Calculate Taxable Amount (before GST)
                const taxableAmount = netAmount / (1 + gstrate / 100);

                // Calculate GST Amount
                const gstAmount = netAmount - taxableAmount;

                // Calculate CGST & SGST (Assuming intra-state transaction)
                const cgstAmount = gstAmount / 2;
                const sgstAmount = gstAmount / 2;

                // Calculate Total Stay
                updatedData.TotalStay = calculateTotalStay(updatedData.CheckIn, updatedData.CheckOut);

                // Update GST fields
                updatedData.RentAmount = netAmount.toFixed(2);
                updatedData.TaxableAmount = taxableAmount.toFixed(2);
                updatedData.CGSTAmount = cgstAmount.toFixed(2);
                updatedData.SGSTAmount = sgstAmount.toFixed(2);
            } else {
                updatedData.TotalStay = "";
            }

            return updatedData;
        });
    };



    // useEffect(() => {
    //     const currentDate = new Date();
    //     console.log("System Time:", currentDate.toLocaleString()); // Logs local system time
    //     const year = currentDate.getFullYear();
    //     const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Ensure two-digit month
    //     const day = String(currentDate.getDate()).padStart(2, '0'); // Ensure two-digit day

    //     const formattedCurrentDate = `${year}-${month}-${day}`; // Format as YYYY-MM-DD

    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         CheckIn: formattedCurrentDate,
    //     }));
    // }, []);

    useEffect(() => {
        const currentDate = new Date();
        const formattedCurrentDate = currentDate.toLocaleDateString('en-CA'); 
        //const formattedCurrentDate = currentDate.toISOString().split('T')[0]; // Always stores UTC date
    
        setFormData((prevFormData) => ({
            ...prevFormData,
            CheckIn: formattedCurrentDate, 
        }));
    }, []);
    



    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setViewportWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isDesktop = viewportWidth > 768;
    const isDesktop1 = viewportWidth > 768;
    const isDesktop2 = viewportWidth > 768;

    const containerStyles = {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        justifyContent: 'space-between',
    };

    const itemStyles = (isDesktop) => ({
        flex: '1 1 100%',
        maxWidth: '100%',
        marginBottom: '16px',
        ...(isDesktop && {
            flex: '1 1 calc(20% - 16px)',
            maxWidth: '20%',
            marginBottom: '0',
        }),
    });

    const itemStyles1 = (isDesktop1) => ({
        flex: '1 1 100%',
        maxWidth: '100%',
        marginBottom: '16px',
        ...(isDesktop1 && {
            flex: '1 1 calc(20% - 16px)',
            maxWidth: '40%',
            marginBottom: '0',
        }),
    });

    const itemStyles2 = (isDesktop2) => ({
        flex: '1 1 100%',
        maxWidth: '100%',
        marginBottom: '16px',
        ...(isDesktop2 && {
            flex: '1 1 calc(20% - 16px)',
            maxWidth: '60%',
            marginBottom: '0',
        }),
    });

    const labelStyles = {
        display: 'block',
        textTransform: 'uppercase',
        fontSize: '14px',
        fontWeight: 'bold',
        marginBottom: '8px',
        color: '#000',
        fontWeight: 'normal'
    };

    const inputStyles = {
        width: '100%',
        padding: '8px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        height: '35px',
        fontSize: '14px',
    };

    function formatDateTime(date) {
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const dd = String(d.getDate()).padStart(2, '0');
        const hh = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        const ss = String(d.getSeconds()).padStart(2, '0');
        return `${hh}:${min}:${ss}`;
    }

    const validateForm = () => {
        
        let errors = [];

        if (!formData.AddressProofId) errors.push("Address Proof is required!");
        if (!formData.ContactNumber) errors.push("Contact Number is required!");
        if (!formData.AddressLine1) errors.push("Address Line 1 is required!");
        if (!formData.SlabId) errors.push("Room Type is required!");
        if (!formData.AddressproofNo) errors.push("Address Proof Number is required!");
        if (!formData.FirstName) errors.push("First Name is required!");
        if (!formData.Purpose) errors.push("Purpose is required!");

        if (errors.length > 0) {
            setErrorMessages(errors);
            return false;
            
        }

        setErrorMessages([]);
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        const totalStay = calculateTotalStay(formData.CheckIn, formData.CheckOut);
        if (isNaN(totalStay) || totalStay <= 0) {
            alert("Invalid check-in or check-out dates.");
            setIsLoading(false);
            return;
        }
        if (validateForm()) {
            const currentTime = formatDateTime(new Date());
            const roomRegister = {
                ...formData,
                // TotalStay: String(formData.TotalStay),
                TotalStay: formData.TotalStay,
                AddressProofId: selectedidcardOptions?.value || selectedidcardOptions,
                Id: 0,
                RoomId: id,
                RentAmount: formData.Amount,
                CreatedBy: userId,
                BranchId: branchId,
                CompanyId: companyId,
                UpdatedDate: null,
                UpdatedBy: null,
                CheckInTime: currentTime
            };

            postData('RoomRegistrationApi', roomRegister, token)
                .then((response) => {
                    console.log('RoomRegistration Created success:', response);
                    history.push('/Home');
                })
                .catch((error) => {
                    console.error('RoomRegistration Create error:', error);
                    setIsLoading(false);
                });
        }
        else
        {
            setIsLoading(false);

        }
    };

    return (
        <div style={containerStyle}>

            <div style={stepBarStyle}>
                <div className="RSPBprogressBar" style={{ width: "100%", position: "relative", marginTop: '-0.75%' }}>
                    <div
                        className="RSPBprogression"
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "55px", // Shifted the progress bar by 5px
                            //width: `${(Object.values(completedSteps).filter(Boolean).length / 3) * 100}%`,
                            // width:'40%',
                            height: "2px",
                            backgroundColor: "#007bff",
                            zIndex: 1,
                            transform: "translateY(-50%)",
                            transition: "width 0.3s ease",
                        }}
                    />


                    {/* Step 1: Left */}
                    {renderStep(1, "rooms", "left")}

                    {/* Step 2: Center */}
                    {renderStep(2, "customer", "center")}

                    {/* Step 3: Right */}
                    {renderStep(3, "idproofs", "right")}
                </div>
            </div>

            {/* {errorMessage && <p className="text-red-500">{errorMessage}</p>} */}
            {errorMessages.length > 0 && (
                <div className="error-box">
                    {errorMessages.map((msg, index) => (
                        <p key={index} className="text-red-500">{msg}</p>
                    ))}
                </div>
            )}
            <div style={tabContentStyle}>

                {activeTab === "rooms" && (
                    <div>
                        <h6 style={{ color: '#164863', fontWeight: 'bold', fontFamily: 'monospace' }}>
                            ROOMS AND TYPES  - <span style={{ color: 'red' }}>{formData.Name}</span> <span style={{ color: '#3B1C32', marginLeft: '5px', fontFamily: 'monospace' }}> CheckOut : {checkouttime}</span>
                        </h6>
                        <div style={containerStyles}>
                            {/* Room Type */}
                            <div style={itemStyles2(isDesktop2)}>
                                <label style={labelStyles} htmlFor="roomType">
                                    Room Type <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select
                                    value={selectedslabOptions || { value: '', label: 'Select Room Type' }}
                                    onChange={handleSlabChange}
                                    options={slabOptions}
                                    placeholder="Select Room Type"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            height: '35px',
                                            minHeight: '35px',
                                            fontSize: '14px',
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                    }}
                                />
                            </div>

                            <div style={itemStyles(isDesktop)}>
                                <label style={labelStyles} htmlFor="amount">
                                    Rent
                                </label>
                                <input
                                    style={{
                                        ...inputStyles,
                                        backgroundColor: '#f8f9fa',
                                        color: '#333',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '4px',
                                    }}
                                    value={`${formData.Amount || ''}`}
                                    type="text"
                                    placeholder="Rent Amount"
                                    name="RentAmount"
                                    readOnly
                                />
                            </div>


                            {/* Discount */}
                            <div style={itemStyles(isDesktop)}>
                                <label style={labelStyles} htmlFor="discount">
                                    Discount
                                </label>
                                <input
                                    style={{
                                        ...inputStyles,
                                        color: '#333',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '4px',
                                    }}
                                    value={`${formData.Discount || '0'}`}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Discount"
                                    name="Discount"
                                    onClick={(e) => e.target.select()}

                                />
                            </div>

                            {/* Total Amount */}
                            <div style={itemStyles(isDesktop)}>
                                <label style={labelStyles} htmlFor="totalAmount">
                                    Final
                                </label>
                                <input
                                    style={{
                                        ...inputStyles,
                                        backgroundColor: '#f8f9fa',
                                        color: '#333',
                                        border: '1px solid #ccc',
                                        padding: '8px',
                                        borderRadius: '4px',
                                    }}
                                    value={formData.RentAmount}
                                    type="text"
                                    placeholder="Total Amount"
                                    readOnly
                                />
                            </div>
                        </div>
                        <br></br>
                        <div style={containerStyles}>
                            {/* Check-In  */}
                            <div style={{ marginBottom: "1rem" }}>
                                <label style={{
                                    //display: 'block',
                                    textTransform: 'uppercase',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    marginBottom: '8px',
                                    color: '#000',
                                    fontWeight: 'normal'
                                }}>
                                    Check-In <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="date"
                                    name="CheckIn"
                                    value={formData.CheckIn}
                                    onChange={handleChange}
                                    style={{ marginLeft: "10px" }}
                                />
                            </div>

                            {/* Check-Out Field */}
                            <div style={{ marginBottom: "1rem" }}>
                                <label style={{
                                    //display: 'block',
                                    textTransform: 'uppercase',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    marginBottom: '8px',
                                    color: '#000',
                                    fontWeight: 'normal'
                                }}>
                                    Check-Out <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="date"
                                    name="CheckOut"
                                    value={formData.CheckOut}
                                    onChange={handleChange}
                                    style={{ marginLeft: "10px" }}
                                />
                            </div>

                            {/* Total Stay */}
                            {/* <div style={itemStyles(isDesktop)}> */}
                            <div style={{ marginBottom: "1rem" }}>
                                <label style={{ ...labelStyles, marginTop: '7px' }} htmlFor="totalAmount">
                                    Total Stay <span style={{ color: "red", marginLeft: '10px', fontWeight: 'bold' }}> {formData.TotalStay}</span>
                                </label>

                            </div>
                            {/* <div style={itemStyles(isDesktop)}> */}
                            <div style={{ marginBottom: "1rem" }}>
                                <label style={{ ...labelStyles, marginTop: '7px' }} htmlFor="totalAmount">
                                    Taxable Amount <span style={{ color: "red", marginLeft: '10px', fontWeight: 'bold' }}> {formData.TaxableAmount}</span>
                                </label>

                            </div>
                            {/* <div style={itemStyles(isDesktop)}> */}
                            <div style={{ marginBottom: "1rem" }}>
                                <label style={{ ...labelStyles, marginTop: '7px' }} htmlFor="totalAmount">
                                    CGST <span style={{ color: "red", marginLeft: '10px', fontWeight: 'bold' }}>{formData.CGSTAmount}</span>
                                </label>

                            </div>

                            {/* <div style={itemStyles(isDesktop)}> */}
                            <div style={{ marginBottom: "1rem" }}>
                                <label style={{ ...labelStyles, marginTop: '7px' }} htmlFor="totalAmount">
                                    SGST <span style={{ color: "red", marginLeft: '10px', fontWeight: 'bold' }}>{formData.SGSTAmount}</span>
                                </label>

                            </div>

                            {/* Total Amount */}
                            {/* <div style={itemStyles(isDesktop)}> */}
                            <div style={{ marginBottom: "1rem" }}>
                                <label style={{ ...labelStyles, marginTop: '7px' }} htmlFor="totalAmount">
                                    Grand Total <span style={{ color: 'red', marginLeft: '10px', fontWeight: 'bold' }}>{(
                                        ((parseFloat(formData.FinalAmount) || 0.0))
                                    ).toFixed(2)}</span>
                                </label>

                            </div>
                        </div>
                    </div>
                )}

                {activeTab === "customer" && (
                    <div>
                        <h6 style={{ color: '#164863', fontWeight: 'bold', fontFamily: 'monospace' }}>
                            CUSTOMER DETAILS
                        </h6>
                        <div style={containerStyles}>

                            <div style={itemStyles1(isDesktop1)}>
                                <label style={labelStyles} htmlFor="roomType">
                                    First Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    style={inputStyles}
                                    value={`${formData.FirstName || ''}`}
                                    type="text"
                                    placeholder="First Name"
                                    name="FirstName"
                                    onChange={handleChange}
                                />
                            </div>

                            <div style={itemStyles1(isDesktop1)}>
                                <label style={labelStyles} htmlFor="amount">
                                    Last Name
                                </label>
                                <input
                                    style={inputStyles}
                                    value={`${formData.LastName || ''}`}
                                    type="text"
                                    placeholder="Last Name"
                                    name="LastName"
                                    onChange={handleChange}
                                />
                            </div>

                            <div style={itemStyles1(isDesktop1)}>
                                <label style={labelStyles} htmlFor="discount">
                                    Contact Number <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    style={inputStyles}
                                    value={`${formData.ContactNumber || ''}`}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Contact Number"
                                    name="ContactNumber"

                                />
                            </div>

                            <div style={itemStyles1(isDesktop1)}>
                                <label style={labelStyles} htmlFor="Email">
                                    Email
                                </label>
                                <input
                                    style={inputStyles}
                                    value={formData.Email}
                                    type="text"
                                    placeholder="Email"
                                    name="Email"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <br></br>
                        <div style={containerStyles}>
                            {/* Check-In  */}
                            <div style={itemStyles1(isDesktop1)}>
                                <label style={labelStyles} htmlFor="Email">
                                    AddressLine 1 <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    style={inputStyles}
                                    value={formData.AddressLine1}
                                    type="text"
                                    placeholder="AddressLine1"
                                    name="AddressLine1"
                                    onChange={handleChange}

                                />
                            </div>

                            <div style={itemStyles1(isDesktop1)}>
                                <label style={labelStyles} htmlFor="Email">
                                    AddressLine 2
                                </label>
                                <input
                                    style={inputStyles}
                                    value={formData.AddressLine2}
                                    type="text"
                                    placeholder="AddressLine2"
                                    name="AddressLine2"
                                    onChange={handleChange}
                                />
                            </div>

                            <div style={itemStyles1(isDesktop1)}>
                                <label style={labelStyles} htmlFor="Email">
                                    Purpose of Visit <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    style={inputStyles}
                                    value={formData.Purpose}
                                    type="text"
                                    placeholder="Purpose of Visit"
                                    name="Purpose"
                                    onChange={handleChange}
                                />
                            </div>

                        </div>
                        <br></br>
                        <div style={containerStyles}>

                            <div style={itemStyles1(isDesktop1)}>
                                <label style={labelStyles} htmlFor="Email">
                                    Remarks
                                </label>
                                <textarea
                                    style={inputStyles}
                                    value={formData.Remarks}
                                    type="text"
                                    placeholder="Remarks"
                                    name="Remarks"
                                    rows={4}
                                    onChange={handleChange}

                                />
                            </div>

                        </div>
                    </div>

                )}

                {activeTab === "idproofs" && (
                    <div>
                        <h6 style={{ color: '#164863', fontWeight: 'bold', fontFamily: 'monospace' }}>
                            ID PROOFS
                        </h6>
                        <div style={containerStyles}>

                            <div style={itemStyles2(isDesktop2)}>
                                <label style={labelStyles} htmlFor="roomType">
                                    ID Type <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select
                                    value={selectedidcardOptions || { value: '', label: 'Select ID Type' }}
                                    onChange={handleIdcardChange}
                                    options={idcardOptions}
                                    placeholder="Select ID Type"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            height: '35px',
                                            minHeight: '35px',
                                            fontSize: '14px',
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                    }}
                                />
                            </div>


                            <div style={itemStyles(isDesktop)}>
                                <label style={labelStyles} htmlFor="amount">
                                    Address proof No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    style={inputStyles}
                                    value={`${formData.AddressproofNo || ''}`}
                                    type="text"
                                    placeholder="Address proof No"
                                    name="AddressproofNo"
                                    onChange={handleChange}
                                />
                            </div>



                            {/* <div style={itemStyles(isDesktop)}>
                                <label style={labelStyles} htmlFor="idProofImage">
                                    Upload Image <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="file"
                                    id="fileUpload"
                                    name="image"
                                    accept="image/jpeg, image/png, image/jpg"
                                    onChange={handleImageChange}
                                />
                            </div>
                            {formData.idProofImage && (
                                <div style={{ marginTop: '16px' }}>
                                    <label style={labelStyles}>ID Proof Preview:</label>
                                    <img
                                        src={formData.idProofImage}
                                        alt="ID Proof"
                                        style={{ width: '100%', maxWidth: '300px', borderRadius: '4px' }}
                                    />
                                </div>
                            )} */}

                        </div>
                    </div>
                )}

            </div>

            <div style={{ textAlign: "right", padding: "20px" }}>
                {activeTab !== "rooms" && (
                    <button
                        onClick={handlePreviousStep}
                        style={{
                            padding: "0px 6px",
                            backgroundColor: "#135D66",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            marginRight: "10px",
                            width: "100px",
                            height: "25px",
                        }}
                    >
                        Previous
                    </button>
                )}
                {activeTab === "idproofs" ? (
                    <button
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{
                            padding: "0px 6px",
                            backgroundColor: "#4B5945", // Green for Submit
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            width: "100px",
                            height: "25px",
                        }}
                    >

                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal' }}>Submit</b>}
                    </button>
                ) : (
                    <button
                        onClick={handleNextStep}
                        style={{
                            padding: "0px 6px",
                            backgroundColor: "#704264",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            width: "100px",
                            height: "25px",
                        }}
                    >
                        Next
                    </button>
                )}
            </div>

        </div >
    );
};

export default RoomRegisterCreate;

